<template>
  <div>
    <el-card>
      <el-button
        size="mini"
        style="width: 90px; margin-left: 50px"
        type="primary"
        @click="addOpen"
        >添加</el-button
      >
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table
        :data="list"
        :header-cell-style="getRowClass"
        border
        ref="multipleTable"
        style="width: 100%; flex: auto"
        tooltip-effect="light"
      >
        <el-table-column
          prop="content"
          label="内容"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createDate"
          label="时间"
          align="center"
        ></el-table-column>
        <el-table-column prop="url" label="图片/视频" align="center">
          <template slot-scope="{ row }">
            <viewer v-if="row.mediaType == 1">
              <img
                v-for="(item, index) in row.url"
                :key="index"
                :src="item"
                alt=""
                style="width: auto; height: 50px"
              />
            </viewer>
            <video
              :src="row.url"
              v-if="row.mediaType == 2"
              controls="controls"
            ></video>
          </template>
        </el-table-column>
        <el-table-column
          prop="mediaType"
          label="类型"
          align="center"
          width="120"
        >
          <template slot-scope="{ row }">
            <span v-if="row.mediaType == 1">图片</span>
            <span v-if="row.mediaType == 2">视频</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          class-name="small-padding fixed-width"
          label="操作"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <div class="done">
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="deleteDetail(row)"
                >删除</el-button
              >
              <el-button
                size="mini"
                style="width: 90px; margin: 0 0 10px 10px"
                type="primary"
                @click="changeDetail(row)"
                >修改</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="width: auto; marginright: 50px; margintop: 20px">
        <el-pagination
          :current-page="currentPage"
          :page-size="pagesize"
          :page-sizes="[5, 10, 15]"
          :total="totalCount"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </el-row>
    </el-card>
    <a-modal
      v-model="visibile"
      title="新增图文详情"
      :footer="null"
      class="broadcast"
      @cancel="closeModel"
    >
      <el-form label-width="90px">
        <el-form-item label="内容">
          <el-col>
            <el-input
              v-model="addList.content"
              type="textarea"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select
            v-model="addList.mediaType"
            clearable
            placeholder="请选择"
            @change="changeSelect"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图片" v-if="show">
          <el-upload
            :action="serverUrl"
            :headers="header"
            list-type="picture-card"
            name="img"
            :limit="9"
            :auto-upload="true"
            :show-file-list="true"
            :file-list="imgList"
            :on-success="upSuccess"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频" v-if="!show">
          <el-upload
            class="avatar-uploader1"
            :action="serverUrl"
            :headers="header"
            name="img"
            :auto-upload="true"
            :show-file-list="false"
            :on-success="upSuccessVideo"
          >
            <video
              v-if="addList.video"
              :src="addList.video"
              class="avatar"
              style="height: 150px"
            />

            <i
              :class="
                loadUpt
                  ? 'el-icon-loading'
                  : 'el-icon-plus avatar-uploader-icon'
              "
              style="margintop: 10px; font-size: 50px"
              v-else
            ></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-button type="primary" size="small" @click="addDeatil">确定</el-button>
    </a-modal>
    <!-- 删除弹出框 -->
    <a-modal
      :visible="delOpen"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>确定要删除吗？</p>
    </a-modal>
    <!-- 修改 -->
    <a-modal
      :visible="changeOpen"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk2"
      @cancel="handleCancel2"
      style="width: 700px"
    >
      <el-form label-width="90px">
        <el-form-item label="内容">
          <el-col :span="20">
            <el-input
              v-model="changeList.content"
              type="textarea"
              :rows="10"
              placeholder="请输入内容"
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="时间">
          <el-col>
            <el-date-picker
              v-model="changeList.createDate"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="视频" v-if="changeList.mediaType == 2">
          <el-col :span="20">
            <el-upload
              class="avatar-uploader"
              :action="serverUrl"
              :headers="header"
              name="img"
              :auto-upload="true"
              :show-file-list="false"
              :on-success="changeVideo"
            >
              <video
                v-if="changeList.url"
                :src="changeList.url"
                class="avatar"
                style="height: 150px"
              />

              <i
                :class="
                  loadUpt
                    ? 'el-icon-loading'
                    : 'el-icon-plus avatar-uploader-icon'
                "
                style="margintop: 10px; font-size: 50px"
                v-else
              ></i>
            </el-upload>
          </el-col>
        </el-form-item>
        <!-- <el-form-item label="视频" v-if="changeList.mediaType == 2">
          <el-col>
            <video :src="changeList.url"></video>
          </el-col>
        </el-form-item> -->
        <el-form-item label="图片" v-if="changeList.mediaType == 1">
          <el-upload
            :file-list="changeImgList"
            :action="serverUrl"
            :headers="header"
            list-type="picture-card"
            name="img"
            :limit="9"
            :auto-upload="true"
            :show-file-list="true"
            :on-success="upSuccess2"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
          <!-- 
          <el-upload
            :file-list="changeImgList"
            :action="serverUrl"
            :headers="header"
            list-type="picture-card"
            name="img"
            :limit="9"
            :auto-upload="true"
            :show-file-list="true"
            :on-success="upSuccess2"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.url"
                alt=""
              />
              <span class="el-upload-list__item-actions">
                <span
                  v-if="!disabled"
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload> -->
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-form-item>
      </el-form>
    </a-modal>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
export default {
  props: ["Detaildata"],
  data() {
    return {
      visibile: false,
      delOpen: false,
      changeOpen: false,
      disabled: false,
      loadUpt: false, //加载
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        // token: localStorage.getItem("key"),
      },
      pagesize: 10, //每页的个数
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示
      addList: {
        content: "",
        valuesImg: "",
        mediaType: "",
        video: "",
        id: "",
      },
      show: true,
      imgList: [],
      changeImgList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      options: [
        {
          value: "1",
          label: "图片",
        },
        {
          value: "2",
          label: "视频",
        },
      ],
      list: [],
      selectVal: "",
      detailId: "",
      changeList: [],
    };
  },
  methods: {
    //将中国标准时间转换为年月日格式  ----开始
    formatTen(num) {
      return num > 9 ? num + "" : "0" + num;
    },
    formatDate(date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      return (
        year +
        "-" +
        this.formatTen(month) +
        "-" +
        this.formatTen(day) +
        " " +
        this.formatTen(hour) +
        ":" +
        this.formatTen(minute) +
        ":" +
        this.formatTen(second)
      );
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    addOpen() {
      this.visibile = true;
    },
    changeSelect(val) {
      this.selectVal = val;
      if (val == 2) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
    upSuccessVideo(file) {
      this.addList.video = file.entity;
    },
    changeVideo(file) {
      this.changeList.url = file.entity;
    },
    upSuccess(file) {
      this.imgList.push({
        url: file.entity,
      });
    },
    upSuccess2(file) {
      this.changeImgList.push({
        url: file.entity,
      });
    },
    handleRemove(file, fileList) {
      this.changeImgList = [];
      this.changeImgList = fileList;
    },
    deleteDetail(row) {
      this.delOpen = true;
      this.detailId = row.id;
    },
    changeDetail(row) {
      this.changeList = row;
      if (row.mediaType == 1) {
        this.changeImgList = [];
        row.url.map((i) => {
          this.changeImgList.push({
            url: i,
          });
        });
      }

      this.changeOpen = true;
    },
    handleOk2() {
      var arr = [];
      if (this.changeList.mediaType == 1) {
        this.changeImgList.map((i) => {
          arr.push(i.url);
        });
        arr = arr.join(",");
      } else {
        arr = this.changeList.url;
      }
      var time = this.formatDate(new Date(this.changeList.createDate));
      this.postAxios("/broadcast/edit/detail", {
        id: this.changeList.id,
        content: this.changeList.content,
        url: arr,
        mediaType: this.changeList.mediaType,
        createDate: time,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.changeOpen = false;
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleCancel2() {
      this.changeOpen = false;
    },
    closeModel() {
      this.addList = {};
      this.imgList = [];
    },
    //不删除：
    handleCancel() {
      this.delOpen = false;
    },
    handleOk() {
      this.getAxios("/broadcast/delete/detail", {
        detailId: this.detailId,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getList();
          this.delOpen = false;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    addDeatil() {
      var id = localStorage.getItem("broadcastId");
      var arr = [];
      if (this.selectVal == 1) {
        this.imgList.map((i) => {
          arr.push(i.url);
        });
        arr = arr.join(",");
      } else {
        arr = this.addList.video;
      }

      this.postAxios("/broadcast/add/detail", {
        broadcastId: id,
        content: this.addList.content,
        url: arr,
        mediaType: this.addList.mediaType,
      }).then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.getList();
        } else {
          this.$message.error(res.message);
        }
        this.visibile = false;
        this.addList = [];
        this.imgList = [];
      });
    },
    getList() {
      this.getAxios("/broadcast/getById", {
        bid: localStorage.getItem("broadcastId"),
      }).then((res) => {
        this.list = res.entity.detailList;
        this.list.map((i) => {
          if (i.mediaType == 1) {
            var arr = i.url.split(",");
            this.$set(i, `url`, arr);
          }
        });
      });
    },
    //分页
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //分页：
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.getList();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  mounted() {
    this.addList.id = this.Detaildata.id;
    localStorage.setItem("broadcastId", this.Detaildata.id);
    this.getList();
  },
  watch: {
    Detaildata(newVal, oldVal) {
      localStorage.setItem("broadcastId", newVal.id);
      this.getList();
    },
  },
};
</script>
<style scoped lang="less">
/deep/.avatar-uploader1 {
  .el-upload {
    width: 200px;
    height: auto;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    outline: 0;
    border: 2px dashed #eee;
    img {
      width: 100%;
      height: auto;
    }
  }
}
// /deep/ .el-upload-list__item-status-label {
//   display: none !important;
// }
// /deep/ .el-upload-list__item-actions {
//   display: none;
// }
/deep/ .ant-modal-content {
  width: 700px;
}
video {
  width: 150px;
  height: 100px;
}
</style>